import React from 'react';
import Image from 'next/legacy/image';

import { ITestimonialFields } from '../../../types/contentful';

import { Testimonial as StyledTestimonial } from './styles';
import {
  ImageWrapper,
  Body,
  BlockText,
  BlockQuote
} from './Testimonial.styles';

import quoteMarks from '@/images/quote-marks.svg';

interface Props extends ITestimonialFields {
  color: string;
}

export function Testimonial({ name, body, color }: Props) {
  return (
    <StyledTestimonial color={color} data-testid="testimonial-block">
      <ImageWrapper>
        <Image src={quoteMarks} alt="Quote Marks" />
      </ImageWrapper>

      <BlockQuote>
        <Body as="p">{body}</Body>
      </BlockQuote>

      <BlockText as="p" fontWeight="600">
        {name}
      </BlockText>
    </StyledTestimonial>
  );
}
